"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeXpath = void 0;
/**
 * This is meant to normalize xpaths produced by different versions of axe-core, to avoid
 * unnecessarily breaking deduplication between results from different axe-core versions.
 *
 * Notably, it normalizes for https://github.com/dequelabs/axe-core/pull/4846, a change in
 * axe-core 4.11 which fixed an xpath generation bug that would sometimes result in selectors
 * like `/foo[@id="bar"]` where it should have been `//foo[@id="bar"]`.
 *
 * Importantly, this normalizes 4.11+ xpaths to look like 4.10 xpaths, *not* the other way
 * around. This is important to ensure backwards compatibility with existing fingerprints
 * from older verisons of jazzband-utils against axe-core 4.10 without this normalization step.
 *
 * See https://github.com/dequelabs/axe-core/issues/4845
 */
const normalizeXpath = (xpath) => {
    return normalizeSelectorComponents(xpath, component => {
        // Converts selectors like `//foo[@id='bar']` to `/foo[@id='bar']`
        const affectedByAxeCore4845Fix = /^\/\/[^/[]+\[@id=/.test(component);
        if (affectedByAxeCore4845Fix) {
            return component.slice(1);
        }
        else {
            return component;
        }
    });
};
exports.normalizeXpath = normalizeXpath;
/**
 * Applies a normalization function to each component of an UnlabelledFrameSelector
 *
 * Example:
 *
 * ```
 * const selector = [['a', 'b'], ['c', 'd'], 'e']
 * const uppercasedSelector = normalizeSelectorComponents(selector, s => s.toUpper())
 * assert.equals(uppercasedSelector, [['A', 'B'], ['C', 'D'], 'E'])
 * ```
 */
const normalizeSelectorComponents = (selector, normalizeComponentFn) => {
    // The outer layer of an UnlabelledFrameSelector *should* be an array and not a string,
    // but we are defensive about this because some issue-mapping libraries normalize to strings.
    if (typeof selector === 'string') {
        return normalizeComponentFn(selector);
    }
    else if (Array.isArray(selector)) {
        return selector.map(crossTreeSelector => {
            if (typeof crossTreeSelector === 'string') {
                return normalizeComponentFn(crossTreeSelector);
            }
            else if (Array.isArray(crossTreeSelector)) {
                return crossTreeSelector.map(normalizeComponentFn);
            }
            else {
                throw new Error('Invalid selector component');
            }
        });
    }
    else {
        throw new Error('Invalid selector');
    }
};
//# sourceMappingURL=normalizeXpath.js.map